import Cookies from "js-cookie";
import moment from "moment";
import DataSource from "../data/datasource";
import { Loading } from 'element-ui';
import axios from "axios";

export const removeElementFromArray = (array, element) => {
    const index = array.indexOf(element);

    if (index !== -1) {
        array.splice(index, 1);
    }
};

export const countDuplicates = (array) => {
    const counts = {};
    array.forEach(function(x) {
        counts[x] = (counts[x] || 0) + 1;
    });
    return counts;
};

export const singleDownload = (FilePath, fileName) => {
    console.log(FilePath, fileName, "FilePath, fileName");
    let a = document.createElement("a");
    a.href = FilePath;
    a.target = "_blank";
    a.download = fileName;
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    a.remove();
};

export const constDateFormat = {
    apiDate: "YYYY-MM-DD",
    default: "DD/MM/YYYY",
    shortMonthLabel: "DD MMM YYYY"
};

export const getFormatDate = (date, format = constDateFormat.default, initFormat) => {
    try {
        if (!date) {
            return null;
        }
        if (initFormat) {
            return moment(date, initFormat).format(format);
        }
        if (format) {
            return moment(date).format(format);
        }

        return date;
    } catch (e) {
        return date;
    }
};

export const cloneObject = (obj) => {
    if (typeof obj === "object") {
        return JSON.parse(JSON.stringify(obj));
    }
    return obj;
};

export const getAge = (date) => {
    let studentDOB = moment(date, "DD/MM/YYYY");
    let age = moment.duration(moment().diff(studentDOB));
    let years = age.years();
    let months = age.months();
    return ({
        years, months
    });
};

export const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds));
};

export const checkEmptyEntry = (data) => {
    return data === null || data === undefined || data === "undefined" || data === "";
};

export const onLoading=(isClose)=>{
    const loading = Loading.service({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
    });
    if(isClose){
        loading.close();
    }
}

export const checkUrlStatus=(url)=>{
    return axios.head(url)
       .then(response => {
           return response.status === 200;
       })
       .catch(() => {
           return false;
       });
}

// Fix error: URI malformed
export const safeDecodeURIComponent = (_content) => {
    const content = _content || '';
    return decodeURIComponent(content.replace(/%/g,'%25'));
}

export const reorderArray=(originalArray)=>{
    originalArray?.sort((a, b) => {
        const orderA = a.PlnMasOrder.split('.').map(Number);
        const orderB = b.PlnMasOrder.split('.').map(Number);

        for (let i = 0; i < Math.min(orderA.length, orderB.length); i++) {
            if (orderA[i] !== orderB[i]) {
                return orderA[i] - orderB[i];
            }
        }

        return orderA.length - orderB.length;
    });

    return originalArray
}

export const generateRandomIndex=()=>{
    return Math.floor(Math.random() * 90000) + 10000;
}

export const isBetweenDate = (startDate, endDate) => {
    let currentDate = moment();
    return currentDate.isBetween(startDate, endDate);
};

export const validatePassword = (string) => {
    const minLength = 8;
    const hasUpperCase = /[A-Z]/.test(string);
    const hasLowerCase = /[a-z]/.test(string);
    const hasSpecialChar = /[!@#\$%\^\&*\)\(+=._-]/.test(string);

    if (string.length < minLength) {
        return 'Password must have at least 8 letters.';
    }
    if (!hasUpperCase) {
        return 'Your password must include at least 1 uppercase letter.';
    }
    if (!hasLowerCase) {
        return 'Your password must include at least 1 lowercase letter.';
    }
    if (!hasSpecialChar) {
        return 'Your password must include at least 1 special character.';
    }
    return '';
};